"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
void i18next_1.default
    .use(i18next_http_backend_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    fallbackLng: 'ja',
    supportedLngs: ['ja', 'en'],
    backend: { loadPath: '/locales/{{lng}}.json' },
    interpolation: { escapeValue: false },
});
const LocaleProvider = ({ children }) => (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: null, children: children });
exports.LocaleProvider = LocaleProvider;
